export default __webpack_public_path__ + "static/media/all-sports-mobile.7129a9a2.png";